import React, { useState, useEffect } from 'react';
import { arrayOf, shape, string, number, bool } from 'prop-types';
import useStyles from 'hooks/useStyles';
import cx from 'classnames';

import styles from './Tabs.scss';

function Tabs({ list, selected, showStickyStyle }) {
  useStyles(styles);
  const [topOfScroll, setTopOfScroll] = useState(0);

  useEffect(() => {
    window.scrollTo({
      top: topOfScroll,
      behavior: 'smooth',
    });
  }, [topOfScroll]);

  const renderTab = ({ sectionId, title, topOfScroll: tabTopOfScroll }) => (
    <div
      key={sectionId}
      className={cx(styles.tab, {
        [styles.selectedTab]: selected === sectionId,
      })}
      onClick={() => setTopOfScroll(tabTopOfScroll)}
    >
      {title}
    </div>
  );

  return (
    <div className={cx(styles.tabs, { [styles.noSticky]: !showStickyStyle })}>
      {list.map(renderTab)}
    </div>
  );
}

Tabs.propTypes = {
  list: arrayOf(
    shape({
      sectionId: string.isRequired,
      title: string.isRequired,
      topOfScroll: number.isRequired,
    }).isRequired,
  ).isRequired,
  selected: string.isRequired,
  showStickyStyle: bool.isRequired,
};

export default Tabs;
